import { render, staticRenderFns } from "./PromotionSetting.vue?vue&type=template&id=609d57fe&scoped=true"
import script from "./PromotionSetting.vue?vue&type=script&lang=js"
export * from "./PromotionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d57fe",
  null
  
)

export default component.exports